<!--
/**
* @name: Home.vue
* @description: 首页
* @author: wenyongjiang
* @create: 2020/07/22 10:57:43
* @update: 2020/07/22 10:57:43
*/
-->
<template>
  <div class="container">
    <div :class="css.home">
      <img src="../assets/images/welcome-img.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checking: false,
    };
  },
  methods: {
    async checkLogin() {
      try {
        const login = await this.$lf.getItem("login");
        if (!login) {
          this.$router.replace({ name: "login" });
          return;
        }
      } catch (err) {
        console.log(err);
      }
      try {
        // this.checking = true;
        // await this.$fetch({
        //   api: '/Api/Home/Index'
        // });
        // this.checking = false;
      } catch (err) {}
    },
  },
  created() {
    this.checkLogin();
    // this.$controller.open(
    //   {
    //     name: '',
    //     query: {
    //       refresh: new Date() - 0
    //     }
    //   },
    //   this.$router.currentRoute.name
    // );
  },
};
</script>

<style module="css" lang="postcss">
.home {
  height: calc(100vh - var(--gutter-x-4));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 55px;
  letter-spacing: 0.2em;
  color: #ccc;
  background-color: #ffffff;
}
</style>
